export const VID_TYPES = [
  { vid: 0, label: "Скидки" },
  { vid: 1, label: "Виды путевок" },
  { vid: 2, label: "Части дня" },
  { vid: 3, label: "Социальные группы" },
  { vid: 4, label: "Виды дополнительных мест" },
  { vid: 5, label: "Виды питания" },
  { vid: 6, label: "Категории контрагентов" },
  { vid: 7, label: "Виды лечения" },
  { vid: 8, label: "Регионы" },
  { vid: 11, label: "Доп. поля контрагентов" },
  { vid: 12, label: "Виды уборки" },
  { vid: 13, label: "Склады" },
  { vid: 31, label: "Филиалы" },
  { vid: 14, label: "Группы объектов аренды" }
];

export const DISCOUNT_ID1_OPTIONS = [
  { value: 0, label: "Размещение" },
  { value: 1, label: "Размещение, Питание, Лечение" }
];

export const MEAL_FLAGS = [
  { key: "breakfast", label: "Завтрак" },
  { key: "lunch", label: "Обед" },
  { key: "snack", label: "Полдник" },
  { key: "dinner", label: "Ужин" }
];

export const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return undefined;
};

export const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const toFlag = (value) => Number(value) === 1;

export const isAllowedVid = (vid) => VID_TYPES.some((t) => t.vid === vid);

export const getVidLabel = (vid) => VID_TYPES.find((t) => t.vid === vid)?.label ?? "";

/** VID с подписью «Лечебная» вместо «Доп.» для IS_OK. */
export const isOkIsLech = (vid) => vid === 1 || vid === 4;

/** Регионы: RAZMER → «Номер». */
export const razmerIsNumber = (vid) => vid === 8;

/** Виды доп. мест: CODE хранит HTML-цвет. */
export const isExtraPlaceVid = (vid) => vid === 4;

/** ColorPicker / произвольная строка → #RRGGBB или "". */
export const normalizeHtmlColor = (value) => {
  if (value == null || value === "") return "";
  let hex = String(value);
  if (typeof value === "object" && value?.toHexString) {
    hex = value.toHexString();
  }
  const m = String(hex)
    .trim()
    .replace(/^#/, "")
    .match(/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!m) return "";
  let body = m[1];
  if (body.length === 3) {
    body = body
      .split("")
      .map((ch) => ch + ch)
      .join("");
  }
  return `#${body.toLowerCase()}`;
};

export const normalizeRow = (row) => ({
  vid: toNumber(pick(row, "vid", "Vid")),
  id: toNumber(pick(row, "id", "Id")),
  name: pick(row, "name", "Name") ?? "",
  razmer: toNumber(pick(row, "razmer", "Razmer")),
  isHide: toFlag(pick(row, "isHide", "IsHide")),
  isOk: toFlag(pick(row, "isOk", "IsOk")),
  id1: toNumber(pick(row, "id1", "Id1")) ?? 0,
  id2: toNumber(pick(row, "id2", "Id2")) ?? 0,
  date1: pick(row, "date1", "Date1"),
  date2: pick(row, "date2", "Date2"),
  code: pick(row, "code", "Code") ?? ""
});

/** Razmer integer 1111 → флаги питания. */
export const razmerToMealFlags = (razmer) => {
  const s = String(Math.round(Number(razmer) || 0)).padStart(4, "0").slice(-4);
  return {
    breakfast: s[0] === "1",
    lunch: s[1] === "1",
    snack: s[2] === "1",
    dinner: s[3] === "1"
  };
};

export const mealFlagsToRazmer = (flags) => {
  const s = [
    flags?.breakfast ? "1" : "0",
    flags?.lunch ? "1" : "0",
    flags?.snack ? "1" : "0",
    flags?.dinner ? "1" : "0"
  ].join("");
  return Number.parseInt(s, 10) || 0;
};
